import React from 'react';
import { useSolplace } from '../context/SolplaceContext';
import './Header.css';

const Header = () => {
  const { wallet, dailyPixels, maxDailyPixels, connectWallet, loading } = useSolplace();

  const formatAddress = (address) => {
    return address.substring(0, 6) + '...' + address.substring(38);
  };

  return (
    <header className="header">
      <div className="logo">
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Solplace logo" className="logo-img" />
        <div className="logo-text">
          <h1>Solplace</h1>
          <div className="logo-sub">Collaborative crypto canvas</div>
        </div>
        <span className="location-tag">China</span>
      </div>
      <div className="wallet-section">
        <a 
          className="twitter-link" 
          href="https://x.com/Solana_Place" 
          target="_blank" 
          rel="noreferrer"
        >
          Twitter
        </a>
        {!wallet ? (
          <button 
            className="connect-btn" 
            onClick={connectWallet}
            disabled={loading}
          >
            {loading ? 'Connecting...' : 'Connect Wallet'}
          </button>
        ) : (
          <div className="wallet-info">
            <div className="address">{formatAddress(wallet)}</div>
            <div className="daily-limit">
              Today's pixels: {dailyPixels}/{maxDailyPixels}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
